class GreatWith extends HTMLElement {
    constructor() {
        super();

        this.checkboxes = this.querySelectorAll('[data-great-with-item]');
        this.totalTarget = this.querySelector('[data-great-with-total]');
        this.message = this.querySelector('[data-great-with-message]');
        this.currentPrice = parseInt(this.getAttribute('data-current-price'), 10) || 0;

        this.form = this.closest('form');
        this.addToCartButton = this.form ? this.form.querySelector('[data-btn-addToCart]') : null;

        this.checkboxes.forEach((checkbox) => {
            checkbox.addEventListener('change', this.onCheckboxChange.bind(this));
        });

        if (this.addToCartButton) {
            this.addToCartButton.addEventListener('click', this.onAddToCartHandler.bind(this), true);
        }

        this.updateTotalPrice();
    }

    onCheckboxChange(event) {
        const mediaId = event.currentTarget.getAttribute('data-media');

        if (mediaId) {
            const media = this.querySelector(`[data-great-with-media="${mediaId}"]`);

            if (media) media.classList.toggle('is-unselected', !event.currentTarget.checked);
        }

        this.updateTotalPrice();
    }

    get selectedItems() {
        return Array.from(this.checkboxes).filter((checkbox) => checkbox.checked && !checkbox.disabled);
    }

    updateTotalPrice() {
        const total = this.selectedItems.reduce((sum, checkbox) => {
            return sum + parseInt(checkbox.getAttribute('data-price'), 10);
        }, this.currentPrice);

        this.totalTarget.innerHTML = Shopify.formatMoney(total, window.money_format);
    }

    onAddToCartHandler() {
        const items = this.selectedItems.map((checkbox) => {
            return { id: parseInt(checkbox.value, 10), quantity: 1 };
        });

        if (items.length === 0) return;

        this.setMessage('');

        fetch(`${window.routes.cart_add_url}.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ items: items })
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.status) {
                    this.setMessage(response.description);
                    return;
                }

                this.updateCartCount();
                document.dispatchEvent(new CustomEvent('cart:refresh'));
                document.dispatchEvent(new CustomEvent('cart:update'));
            })
            .catch((e) => {
                console.error(e);
                this.setMessage('Sorry, we could not add these items to your cart.');
            });
    }

    updateCartCount() {
        fetch(`${window.routes.cart}.js`)
            .then((response) => response.json())
            .then((cart) => {
                document.querySelectorAll('[data-cart-count]').forEach((element) => {
                    element.textContent = cart.item_count;
                });
            })
            .catch((e) => console.error(e));
    }

    setMessage(text) {
        this.message.textContent = text;
        this.message.hidden = text === '';
    }
}

customElements.define('great-with', GreatWith);
